import { useQuery } from '@tanstack/react-query';
import { getTags } from './services';
import { Tag } from 'features/common/types';

/** The backend may return either a bare array or a `{ tags: [...] }` envelope. */
type GetTagsResponse = Tag[] | { tags: Tag[] };

export const useTagsApi = () => {
	const {
		data: tags,
		isLoading,
		refetch,
	} = useQuery({
		queryKey: ['tags'],
		queryFn: getTags,
		initialData: [] as Tag[],
		select: (data): Tag[] => {
			// Normalise both the bare-array and { tags: [...] } envelope shapes.
			const response = data as GetTagsResponse;
			if (Array.isArray(response)) return response;
			if (response && typeof response === 'object' && 'tags' in response) return response.tags;
			return [];
		},
	});

	return {
		tags,
		isLoading,
		refetch,
	};
};
